import { render, staticRenderFns } from "./EditLinks.vue?vue&type=template&id=48221ad7&scoped=true&"
import script from "./EditLinks.vue?vue&type=script&lang=js&"
export * from "./EditLinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48221ad7",
  null
  
)

export default component.exports